// import { animate } from 'motion'

export default defineNuxtPlugin((nuxtApp) => {
    const { loaded, loadingShown } = useClientState()
    nuxtApp.hook('page:loading:end', () => {
        // const anim = animate('.loading-screen', {
        //     opacity: [1, 0],
        // }, {
        //     duration: 1, easing: [.13,.39,.47,.97], fill: 'both', composite: 'replace', allowWebkitAcceleration: true,
        // })
        // anim.finished.then(() => {
        loaded.value = true
        loadingShown.value = false
        // })
    })
})
